<template>
<div class="ex-wrapper">
		<div class="heading">Form Radio</div>
		<div class="description">All Information about Form Radio.</div>

    <div class="example-set">
      <div class="row">
        <div class="col-md-4 example">
          <div class="radio-group">
            <input class="radio-true" type="radio" id="rdo1" value="1" name="selector1">
            <label class="radio-fake" for="rdo1"></label>
            <label class="radio-label" for="rdo1">Label 1</label>
          </div>
          <div class="radio-group">
            <input class="radio-true" type="radio" id="rdo2" value="2" name="selector1">
            <label class="radio-fake" for="rdo2"></label>
            <label class="radio-label" for="rdo2">Label 2</label>
          </div>
          <div class="radio-group">
            <input class="radio-true" type="radio" id="rdo3" value="3" name="selector1">
            <label class="radio-fake" for="rdo3"></label>
            <label class="radio-label" for="rdo3">Label 3</label>
          </div>
          <div class="radio-group">
            <input class="radio-true" type="radio" id="rdo4" value="4" name="selector2" disabled="disabled">
            <label class="radio-fake" for="rdo4"></label>
            <label class="radio-label" for="rdo4">Label 1 Disable</label>
          </div>
          <div class="radio-group">
            <input class="radio-true" type="radio" id="rdo5" value="5" name="selector2" disabled="disabled" checked="checked">
            <label class="radio-fake" for="rdo5"></label>
            <label class="radio-label" for="rdo5">Label 2 Disable</label>
          </div>
        </div>
        <div class="col-md-8 spacing">&nbsp;</div>
      </div>
    </div>
		
	</div>
</template>

<script>
var Prism = require('prismjs')
var code = `

`
var html = Prism.highlight(code, Prism.languages.markup)

export default {
  name: 'ex-radio',
  data () {
    return {
      tag: html
    }
  },
  created () {
    // console.log(this.tag)
  }
}
</script>


// WEBPACK FOOTER //
// ex-radio.vue?717914c6